<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  score: number
}>()
const circumference = 2 * Math.PI * 90
const offset = computed(() => circumference - (props.score / 100) * circumference)
const color = computed(() => {
  if (props.score >= 80) return '#10b981'
  if (props.score >= 60) return '#f59e0b'
  return '#ef4444'
})
const bgColor = computed(() => {
  if (props.score >= 80) return '#10b98120'
  if (props.score >= 60) return '#f59e0b20'
  return '#ef444420'
})
</script>

<template>
  <div class="flex items-center justify-center">
    <div class="relative">
      <svg
        class="transform -rotate-90"
        width="200"
        height="200"
        viewBox="0 0 200 200"
      >
        <circle
          cx="100"
          cy="100"
          r="90"
          :stroke="bgColor"
          stroke-width="20"
          fill="none"
        />
        <circle
          cx="100"
          cy="100"
          r="90"
          :stroke="color"
          stroke-width="20"
          fill="none"
          stroke-linecap="round"
          :stroke-dasharray="circumference"
          :stroke-dashoffset="offset"
          class="transition-all duration-1000 ease-out"
        />
      </svg>
      <div class="absolute inset-0 flex flex-col items-center justify-center">
        <div
          class="text-5xl font-bold"
          :style="{ color }"
        >
          {{ score }}
        </div>
        <div class="text-sm text-gray-600 mt-1">
          out of 100
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
svg circle {
  transition: stroke-dashoffset 1s ease-in-out;
}
</style>
